import '../assets/fonts/fonts.css';
import { NavLink } from 'react-router-dom';

export default function MolinHeader() {
  return (
    <div>
      <div className="absolute w-auto top-[3vw] right-[3vw]  z-[9999]">
        <nav className="flex justify-end space-x-[5.7vw] ml-auto">
          <NavLink
            to="/mainstreet"
            className="text-[1vw] tracking-wider font-normal transition-transform hover:scale-110  text-[#000]"
          >
            <div className="flex flex-col text-center w-[15vw] rounded-[3vw] bg-[rgba(255,255,255,0.3)] hover:bg-[rgba(255,255,255,0.7)]  backdrop-blur-sm">
              <span className=' mt-[0.5vw]'>返回大街</span>
              <span className=" mb-[0.5vw] text-[1vw] transform translate-x-[0.4vw] -translate-y-[0.2vw]">
                Back to Main Street
              </span>
            </div>
          </NavLink>
        </nav>
      </div>
    </div>
  )
}